<script>import Input from "../Input.svelte";
import SVG from "../../SVG.svelte";
import Hint from "../../Hint.svelte";
import DynamicComponent from "../../../components/DynamicComponent.svelte";
export let props;
$: props.key = props.key ?? "checkbox";
let isErrorDisplayed;
const handleChange = () => {
  if (!props.touched) {
    props.touched = true;
  }
  if (!props.dirty) {
    props.dirty = true;
  }
};
</script>

<div>
	<Input bind:props bind:isErrorDisplayed isLabelHidden={true}>
		<label
			for={props.id}
			class:cursor-not-allowed={props.disabled}
			class:cursor-pointer={!props.disabled}
			class="inline-flex"
		>
			<input
				required={props.required}
				disabled={props.disabled}
				id={props.id}
				type="checkbox"
				class="custom-checkbox mt-1"
				class:cursor-pointer={!props.disabled}
				bind:checked={props.checked}
				bind:this={props.ref}
				on:change|once={() => handleChange()}
				on:change
			/>
			{#if props.icon}
				<SVG classNames="ml-2" name={props.icon} />
			{/if}
			{#if props.label}
				<span class="ml-2 first-letter:uppercase" class:font-bold={props.boldLabel}>
					{#if props.label.component}
						<DynamicComponent component={props.label} />
					{:else if typeof props.label == 'string'}
						{@html props.label}
					{:else}
						<DynamicComponent component={props.label} />
					{/if}
					{#if props.required}
						<span class="text-primary">*</span>
					{/if}
				</span>
			{/if}
			{#if props.hint}
				<div class="ml-2 inline-flex items-center">
					<Hint tooltip={{ title: props.hint }} />
				</div>
			{/if}
		</label>
	</Input>
</div>

<style>.custom-checkbox{-webkit-appearance:none;-moz-appearance:none;appearance:none;border-radius:.125rem;border-width:1px;box-sizing:border-box;display:inline-block;flex-shrink:0;height:1rem;width:1rem;--tw-border-opacity:1;border-color:#c4c4c4;border-color:rgba(196,196,196,var(--tw-border-opacity,1));--tw-bg-opacity:1;background-color:#fff;background-color:rgba(255,255,255,var(--tw-bg-opacity,1));color:var(--color-primary);padding:0;vertical-align:middle}.custom-checkbox,.custom-checkbox:focus{--tw-ring-offset-shadow:var(--tw-ring-inset) 0 0 0 var(--tw-ring-offset-width) var(--tw-ring-offset-color);--tw-ring-shadow:var(--tw-ring-inset) 0 0 0 calc(var(--tw-ring-offset-width)) var(--tw-ring-color);box-shadow:var(--tw-ring-offset-shadow),var(--tw-ring-shadow),0 0 transparent;box-shadow:var(--tw-ring-offset-shadow),var(--tw-ring-shadow),var(--tw-shadow,0 0 transparent)}.custom-checkbox:focus{--tw-ring-color:transparent}.custom-checkbox{background-origin:border-box}.custom-checkbox:checked{background-color:var(--color-primary);background-image:url("data:image/svg+xml;charset=utf-8,%3Csvg xmlns='http://www.w3.org/2000/svg' fill='%23fff' viewBox='0 0 16 16'%3E%3Cpath d='M5.707 7.293a1 1 0 0 0-1.414 1.414l2 2a1 1 0 0 0 1.414 0l4-4a1 1 0 0 0-1.414-1.414L7 8.586z'/%3E%3C/svg%3E");background-position:50%;background-repeat:no-repeat;background-size:100% 100%;border-color:transparent}.custom-checkbox:disabled{cursor:not-allowed;--tw-border-opacity:1;border-color:#f7f7f7;border-color:rgba(247,247,247,var(--tw-border-opacity,1))}</style>
